module.exports = __webpack_public_path__ + "img/lg_ring_r_e_0_1@3x.87452146.png";